import React, { Fragment } from "react";
import {createInitialState, ListView, ListViewProps, ListViewState} from "../ListView";
import {PayoutsListRequest, User} from "../../http/protocol";
import {Form, FormListener} from "../form/Form";
import {getContainer} from "../../ioc/IOCSetup";
import {EntityDataTable} from "../list/list/EntityDataTable";
import {ActionType} from "../list/list/DataTable";
import {AffiliatesPaymentService} from "../../services/AffiliatesPaymentService";
import {ColumnType} from "../list/list/ColumnType";
import { PagerModel } from "../list/list/PagerModel";
import { ListUtils } from "../list/list/ListUtils";
import {FormGroup} from "../form/FormGroup";
import {FormInput} from "../form/FormInput";
import {Validators} from "../form/Validators";
import {Submit} from "../form/Submit";


interface State extends ListViewState<PayoutsListRequest> {
    listRequest? : PayoutsListRequest;
    form? : PayoutsListRequest;
    validationMap? : any;
}
interface Props extends ListViewProps  {

}

export default class AffiliatesReportPayoutsView extends ListView<State, PayoutsListRequest> implements FormListener<PayoutsListRequest> {
    service: AffiliatesPaymentService;

    columns = [
        { property : "id", name : "ID"},
        { property : "affiliateId", name : "Affiliate ID"},
        { property : "affiliate.cashoutUserId", name : "Cashout ID"},
        { property : "month", name : "Month", type: ColumnType.TEXT},
        { property : "amount", name : "Amount"},
        { property : "grossRevenue", name : "GrossRevenue"},
        { property : "netRevenue", name : "NetRevenue"},
        { property : "bonusCost", name : "BonusCost"},
        { property : "networkCost", name : "NetworkCost"},
        { property : "percentage", name : "Percentage"},
        { property : "profit", name : "Profit"},
        { property : "carryOver", name : "CarryOver"},
        { property : "currency", name : "Currency"},
        { property : "status", name : "Status"},
        { property : "progress", name : "Progress"},
    ];

    actions = [
        { id : "view", name : "Go to Affiliate", className : "btn btn-primary", iconClassName : "fa fa-user", type : ActionType.LINK, getLink : (item : any) => "/affiliates/user/" + item.affiliateId },

    ];

    onAction(item : User, action : string) : Promise<any> | undefined {
        return;
    }

    initialState : PayoutsListRequest = {
        limit: 20,
        month:undefined,
        affiliateId:undefined,
        cashoutId:undefined
    }

    constructor(props:Props) {
        super(props, '/affiliates/reports/payouts');


        this.service = getContainer().getAffiliatesPaymentService();
        this.state = createInitialState(
            this.initialState,
            this.state = {...this.state});
    }

    formDidUpdate(formModel: PayoutsListRequest, validationMap?: any): void {
        this.setState({form : formModel, validationMap : validationMap});
    }

    clearForm(e:any) {
        e.preventDefault();
        return this.setState({form:{}});
    }

    onSubmit(){
        let listRequest : PayoutsListRequest = Object.assign({},this.state.form);
        listRequest.offset = 0;
        if(listRequest.limit === undefined || listRequest.limit===0){
            listRequest.limit = 20;
        }
        if(listRequest.month!==undefined){
            let date = listRequest.month.toString().concat("-01").split("-");
            let newDate = new Date(Number(date[0]),Number(date[1])-1,Number(date[2]),0,0,0);
            listRequest.month= newDate;
        }
        this.setState({listRequest:listRequest});
    }

    pagerChanged(pager : PagerModel) {
        if(this.state.listRequest) {
            let listRequest = ListUtils.toListRequest<any>(this.state.listRequest,pager);
            this.setState({listRequest:listRequest});
        }
    }

    getTitle() {
        return "List Affiliates Payouts"
    }

    getSearchByAffiliateId() {
        return(
            <div className="row">
                <div className={"col-lg-4"}>
                    <div className="card-box">
                        <h4>Find By Affiliate ID</h4>
                        <Form formListener={this} modelObject={this.state.form} validationMap={this.state.validationMap}>
                            <FormGroup className={"form-group"} model="affiliateId">
                                <FormInput model={"affiliateId"} className={"form-control"} validators={[Validators.integer()]}/>
                                <span className={"help-text"}>Finds reports by affiliate id. Exact match only.</span>
                            </FormGroup>
                            <Submit className={"btn btn-primary"} style={{marginRight:"15px"}}>Search</Submit>
                            <button className="btn-xs btn-new-default" onClick={(e) => this.clearForm(e)}>Clear filters</button>
                        </Form>
                    </div>

                </div>
                
                <div className={"col-lg-4"}>
                    <div className="card-box">
                        <h4>Find By Cashout ID</h4>
                        <Form formListener={this} modelObject={this.state.form} validationMap={this.state.validationMap}>
                            <FormGroup className={"form-group"} model="cashoutId">
                                <FormInput model={"cashoutId"} className={"form-control"} validators={[Validators.integer()]}/>
                                <span className={"help-text"}>Find reports by cashout id. Exact match only.</span>
                            </FormGroup>
                            <Submit className={"btn btn-primary"} style={{marginRight:"15px"}}>Search</Submit>
                            <button className="btn-xs btn-new-default" onClick={(e) => this.clearForm(e)}>Clear filters</button>
                        </Form>
                    </div>

                </div>

                <div className={"col-lg-4"}>
                    <div className="card-box">
                        <h4>Find By Month-Year</h4>
                        <Form formListener={this} modelObject={this.state.form} validationMap={this.state.validationMap}>
                            <FormGroup className={"form-group"} model="month">
                                <FormInput model={"month"} className={"form-control"} type={"month"}/>
                                <span className={"help-text"}>Find reports by month-year.</span>
                            </FormGroup>
                            <Submit className={"btn btn-primary"} style={{marginRight:"15px"}}>Search</Submit>
                            <button className="btn-xs btn-new-default" onClick={(e) => this.clearForm(e)}>Clear filters</button>
                        </Form>
                    </div>

                </div>
            </div>
        )
    }

    renderContent() {
        if(!this.state.listRequest) {
            return <div/>;
        }
        return (
            <Fragment>
                {this.getSearchByAffiliateId()}
                <EntityDataTable service={this.service}
                                onPagerChange={this.pagerChanged.bind(this)}
                                columns={this.columns}
                                listRequest={this.state.listRequest}
                                onAction={this.onAction.bind(this)}
                                actions={this.actions}
                                setMaxLimit={100} />
            </Fragment>
        );
    }
}